<script>
    import { CommonBus } from '../../../../../../app';

    export default {
        name: 'design-2021-assignment-edit-part-matching-list-component',
        props: {
            partIn: {
                type: Object,
                required: true
            },
            canEditPortfolio: {
                type: Boolean,
                required: false,
                default: false
            },
            ords: Boolean
        },
        data() {
            return {
                questionTitle: [],
                part: this.partIn
            };
        },
        computed: {
            options() {
                let rawOptions = this.partIn.list_options.map((listOption) => {
                    return {
                        value: listOption.id,
                        text: listOption.value
                    };
                });

                rawOptions.unshift({ value: null, text: 'Maak een keuze' });
                return rawOptions;
            }
        },

        created() {
            for (const name of this.partIn.list_items) {
                this.questionTitle.push({ edit: false });
            }
        },

        methods: {
            showEditModal() {
                this.$refs['answer-options-modal'].show();
            },

            updateQuestionTitle(value, item) {
                this.$emit('call-update-item', value, item);
            },

            deleteItem(item) {
                this.$emit('call-delete-item', item);
            },

            editQuestion() {
                CommonBus.$emit('enable-edit-mode');
            },

            updatePart(part) {
                this.$emit('update-part', part);
            },
            updateListItem(newItem) {
                let part = this.partIn;
                part.list_items = part.list_items.map((item) => {
                    if (item.id === newItem.id) {
                        return newItem;
                    }
                    return item;
                });

                this.updatePart(part);
            },
            addListItem(newItem) {
                let part = this.partIn;
                part.list_items.push(newItem);

                this.updatePart(part);
            }
        },

        watch: {
            partIn: {
                handler: function(newVal) {
                    this.part = newVal;
                },
                deep: true
            }
        }
    };
</script>

<template>
    <div class="assignment-choice-shuffle-example">
        <b-alert variant="warning" show v-if="partIn.list_items.length !== partIn.list_options.length">
            {{ $t('assignment.edit_match_list_uneven_options') }}
        </b-alert>

        <div class="questions">
            <h6 class="header">Vragen</h6>

            <div
                class="question-item"
                v-for="item in partIn.list_items"
                :key="item.id">
                <div class="header">
                    <design-2021-assignment-edit-type-assignment-part-list-item-component
                        v-if="ords"
                        :can-edit-portfolio="canEditPortfolio"
                        @list-item-updated="updateListItem"
                        :item-in="item">
                    </design-2021-assignment-edit-type-assignment-part-list-item-component>
                    <design-2021-lesson-module-assignment-type-assignment-part-list-item-component
                        v-else
                        @list-item-updated="updateListItem"
                        :item-in="item">
                    </design-2021-lesson-module-assignment-type-assignment-part-list-item-component>
                </div>

                <b-button
                    class="btn-remove btn-remove-question"
                    v-if="canEditPortfolio"
                    v-b-tooltip.hover
                    variant="danger-icon-only"
                    title="Verwijderen"
                    :disabled="partIn.list_items.length === 1"
                    @click="deleteItem(item)">
                </b-button>
            </div>

            <div
                class="add-question"
                v-if="canEditPortfolio">
                <design-2021-assignment-edit-type-assignment-part-list-question-component
                    v-if="ords"
                    :part-in="partIn">
                </design-2021-assignment-edit-type-assignment-part-list-question-component>

                <design-2021-lesson-module-assignment-type-assignment-part-list-question-component
                    v-else
                    @list-item-added="addListItem"
                    :part-in="partIn">
                </design-2021-lesson-module-assignment-type-assignment-part-list-question-component>
            </div>
        </div>

        <div class="answers">
            <ul class="answers-list">
                <li class="header">Antwoorden</li>
                <li
                    v-for="option in partIn.list_options"
                    class="answer-item">
                    {{ option.value }}
                </li>
            </ul>

            <div class="add-answer">
                <b-button
                    class="btn-edit btn-new-answer-option"
                    variant="primary"
                    @click="showEditModal()">
                    {{ $t('assignment.edit_answer_options') }}
                </b-button>
            </div>

            <design-2021-assignment-edit-answer-options-modal
                :ords="ords"
                ref="answer-options-modal"
                @part-updated="updatePart"
                :part-in="partIn">
            </design-2021-assignment-edit-answer-options-modal>
        </div>

        <div class="preview">
            <h6>{{ $t('common.preview') }}</h6>

            <design-2021-assignment-show-matching-list-component
                :part-in="part"
                :is-example-in="true"
                :ords="false">
            </design-2021-assignment-show-matching-list-component>
        </div>

    </div>
</template>

<style scoped lang="scss">
    .assignment-choice-shuffle-example {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        row-gap: $grid-gutter-width;
        margin-top: $grid-gutter-width;
    }

    .questions,
    .answers,
    .answers-list {
        display: flex;
        flex-direction: column;
        row-gap: map-get($grid-gutter-spacing, 'fifteen');
    }

    .question-item {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');

        .btn-remove-question {
            flex: 0 0 auto;
        }

        .header {
            flex: 1 0 calc(100% - 35px);
        }
    }

    .add-question,
    .add-answer {
        margin-top: map-get($grid-gutter-spacing, 'fifteen');
    }

    .answers-list {
        list-style: none;
        padding-left: 0;

        .header {
            font-weight: $font-weight-medium;
            font-size: $base-font-size;
        }

        .answer-item {
            height: 21px;
        }
    }


    @media (min-width: map-get($grid-breakpoints, 'xl')) {
        .assignment-choice-shuffle-example {
            column-gap: $grid-gutter-width;
            flex-direction: row;
        }

        .questions,
        .answers {
            flex: 1 0 calc(50% - 15px);
        }

        .add-question,
        .add-answer {
            margin-top: auto;
        }

    }

    @media (min-width: map-get($grid-breakpoints, 'xxl')) {
        .questions {
            flex: 1 0 calc(70% - 15px);
        }

        .answers {
            flex: 1 0 calc(30% - 15px);
        }
    }
</style>